export default __webpack_public_path__ + "static/media/poc_one.d2226800.glb";